const stickyStyling = () => {
  (($) => {
    const el = {
      key: "value",
    };

    const init = () => {
      exec();
    };

    const exec = () => {
      // Initialize the observer when the DOM is ready
      $(function () {
        if (window.elementorFrontend) {
          /* global elementorFrontend */
          elementorFrontend.hooks.addAction(
            "frontend/element_ready/global",
            function ($scope) {
              initStickyObserver();
            }
          );
        }
      });
    };

    const hasStickyEffects = (element) => {
      return element.classList.contains("elementor-sticky--effects");
    };

    const initStickyObserver = () => {
      // Select all sticky elements
      const stickyElements = document.querySelectorAll(".elementor-sticky");

      if (!stickyElements.length) {
        console.warn("No .elementor-sticky elements found on the page");
        return null;
      }

      // Configure the observer
      const observerConfig = {
        attributes: true,
        attributeFilter: ["class"],
        subtree: false,
      };

      // Create mutation observer
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const element = mutation.target;

          if (hasStickyEffects(element)) {
            $(element)
              .children()
              .filter(".e-con.e-child:first-child")
              .slideUp();
            $(element)
              .next()
              .children()
              .filter(".e-con.e-child:first-child")
              .slideUp();
          } else {
            $(element)
              .children()
              .filter(".e-con.e-child:first-child")
              .slideDown();
            $(element)
              .next()
              .children()
              .filter(".e-con.e-child:first-child")
              .slideDown();
          }
        });
      });

      // Start observing each sticky element
      stickyElements.forEach((element) => {
        observer.observe(element, observerConfig);
      });

      // Function to disconnect the observer
      const disconnectObserver = () => {
        observer.disconnect();
      };

      // Return both the observer and disconnect function
      return { observer, disconnectObserver };
    };

    init();
    /* global jQuery */
  })(jQuery);
};

try {
  stickyStyling();
} catch (error) {
  console.error(error);
}
